import Email from 'components/Main/Emails/Email'
import useFetch from 'elements/Hooks/useFetch'
import React from 'react'

function EmailCont({ owner }) {
  const { data: list, fetching, fetch } = useFetch({
    url: owner ? `/emails/owner/${owner}` : '/emails?select=_id,_key,to,cc,bcc,from,subject,owner,detail',
  })

  return (
    <Email
      {...{
        owner,
        list,
        fetching,
        fetch,
      }}
    />
  )
}

export default EmailCont
